jQuery(document).ready(function ($) {
  if (document.getElementById('page-estrutura-adm')) {

    //lógica acordeons
    const accordions = document.querySelectorAll('.accordion');
// Add event listener to each accordion
    accordions.forEach(accordion => {
      const headers = accordion.querySelectorAll('.accordion-header');
      const accordionButton = accordion.querySelectorAll('.open-close-all .mi');

      accordionButton.forEach(function (acB){
        acB.addEventListener('click', () => {
          if (acB.innerHTML === 'expand') {
            headers.forEach(header => {
              if (header.classList.contains('collapsed')) {
                header.click();
              }
            });
          } else if (acB.innerHTML === 'unfold_less') {
            headers.forEach(header => {
              if (!header.classList.contains('collapsed')) {
                header.click();
              }
            });
          }
        })
      });
      });
        // fim da lógica dos acordeons
  }
});
